import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/modules/shared/services/sites.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardUtils } from 'src/app/modules/shared/DashboardUtils';
import { timer, Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-dashboard-site-grupo-chiller-page',
    templateUrl: './dashboard-site-grupo-chiller-page.component.html',
    styleUrls: ['./dashboard-site-grupo-chiller-page.component.css']
})
export class DashboardSiteGrupoChillerPageComponent implements OnInit, OnDestroy {

    public site: any;
    public realTimeCards: any[];
    public charts: any[];
    private refreshCardDataSubscription: Subscription;
    private refreshChartDataSubscription: Subscription;

    constructor(private route: ActivatedRoute, public authenticationService: AuthenticationService, private sitesService: SitesService, private dataService: DataService,
        private spinner: NgxSpinnerService) {
        this.realTimeCards = [];
        this.charts = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.spinner.show();
            this.sitesService.get(params['id']).subscribe(response => {
                this.site = response;

                var grupoChillers = this.site.grupoChillers[0];

                // 1. Card de Geração de Agua Gelada
                if(grupoChillers.tagGeracaoAguaGelada && grupoChillers.tagGeracaoAguaGelada.tagRealTimeValue) {
                    let cardGeracaoAguaGelada = { tags: [], getIconClass: () => 'image-chiller-on', iconWidth: "32px", getLabel: () =>  `GERAÇÃO DE ÁGUA GELADA`, getValue: () => {}};
                    cardGeracaoAguaGelada.tags.push({ tag: grupoChillers.tagGeracaoAguaGelada.tagRealTimeValue });  
                    cardGeracaoAguaGelada.getValue = () => !isNaN(cardGeracaoAguaGelada.tags[0].value) ? (cardGeracaoAguaGelada.tags[0].value.toFixed(1)==-0?"0,0TR":cardGeracaoAguaGelada.tags[0].value.toFixed(1).replace(/[.]/, ",") + "TR") : '-';
                    this.realTimeCards.push(cardGeracaoAguaGelada);
                }
                
                // 2. Card de Temperatura de Envio de Agua Gelada

                if(grupoChillers.tagTemperaturaEnvioAguaGelada && grupoChillers.tagTemperaturaEnvioAguaGelada.tagRealTimeValue) {
                    let cardTemperaturaEnvio = { tags: [], getIconClass: () => "image-temperatura", iconWidth: "14px", getLabel: () =>  `TEMP ENVIO`, getValue: () => {}};
                    cardTemperaturaEnvio.tags.push({ tag: grupoChillers.tagTemperaturaEnvioAguaGelada.tagRealTimeValue });
                    cardTemperaturaEnvio.getValue = () => !isNaN(cardTemperaturaEnvio.tags[0].value) ? (cardTemperaturaEnvio.tags[0].value.toFixed(1)==-0?"0,0ºC":cardTemperaturaEnvio.tags[0].value.toFixed(1).replace(/[.]/, ",") + "ºC") : "-";
                    this.realTimeCards.push(cardTemperaturaEnvio);  
                }
                
                
                // 3. Card de Temperatura de Retorno de Agua gelada

                if(grupoChillers.tagTemperaturaRetornoAguaGelada && grupoChillers.tagTemperaturaRetornoAguaGelada.tagRealTimeValue) {
                    let cardTemperaturaRetorno = { tags: [], getIconClass: () => "image-temperatura", iconWidth: "14px", getLabel: () =>  `TEMP RETORNO`, getValue: () => {}};
                    cardTemperaturaRetorno.tags.push({ tag: grupoChillers.tagTemperaturaRetornoAguaGelada.tagRealTimeValue });                
                    cardTemperaturaRetorno.getValue = () => !isNaN(cardTemperaturaRetorno.tags[0].value) ? (cardTemperaturaRetorno.tags[0].value.toFixed(1)==-0?"0,0ºC":cardTemperaturaRetorno.tags[0].value.toFixed(1).replace(/[.]/, ",") + "ºC") : "-";
                    this.realTimeCards.push(cardTemperaturaRetorno);
                }
                
                // 4. Cards de Status dos Chillers
                grupoChillers.chillers.forEach((chiller, index) => {
                    let iconsByStatus = {};
                    iconsByStatus['0'] = "image-chiller-off";
                    iconsByStatus['1'] = "image-chiller-on";
                    iconsByStatus['2'] = "image-chiller-alarm";
                    iconsByStatus['3'] = "image-chiller-off";
                    iconsByStatus['4'] = "image-chiller-off";

                    let cardChiller = { tags: [], getIconClass: () => iconsByStatus[cardChiller.tags[0].value] ? iconsByStatus[cardChiller.tags[0].value] : 'image-chiller-off', iconWidth: "32px", getLabel: () =>  chiller.name, getValue: () => {}};
                    cardChiller.tags.push({ tag: chiller.tagStatus.tagRealTimeValue });
                    cardChiller.getValue = () => "";                                
                    this.realTimeCards.push(cardChiller);
                });

                // 1. Gráfico de Geração de Agua Gelada
                if(grupoChillers.tagGeracaoAguaGelada && grupoChillers.tagGeracaoAguaGelada.tagHistoricalValues) {
                    let chartGeracaoAguaGelada = DashboardUtils.buildDefaultChart("Geração de Água Gelada (TR)", grupoChillers.tagGeracaoAguaGelada);
                    this.updateChart(chartGeracaoAguaGelada);
                    this.charts.push(chartGeracaoAguaGelada);
                }
            
                this.refreshCardDataSubscription = timer(0, environment.dashboard.cardUpdatePeriodSeconds * 1000).subscribe(result => { 
                    this.refreshCardData();
                });
                this.refreshChartDataSubscription = timer(0, environment.dashboard.chartUpdatePeriodSeconds * 1000).subscribe(result => { 
                    this.refreshChartData();
                });
                
                this.spinner.hide();
            });
        });
    }

    ngOnDestroy() {
        if(this.refreshCardDataSubscription) this.refreshCardDataSubscription.unsubscribe();
        if(this.refreshChartDataSubscription) this.refreshChartDataSubscription.unsubscribe();
    }

    refreshCardData() {
        var tags = [];
        this.realTimeCards.forEach(c => tags = tags.concat(c.tags));
        this.dataService.read({items: tags}).subscribe(response => {
            for(let i in response.data) {
                Object.assign(tags[i], response.data[i]);                
            }
        });
    };

    refreshChartData() {
        this.charts.forEach(chart => {            
            this.updateChart(chart);    
        });
    };

    updateChart(chartToUpdate) {
        DashboardUtils.updateChart(this.dataService, chartToUpdate);
    };
}
